"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettyDate = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _Hero = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _QouteSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection");

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _ItemWithImageDescriptionAndIcons = require("@quixeltools/quixel-ui-library/dist/components/common/website/ItemWithImageDescriptionAndIcons");

var _ItemWithImageDescriptionAndIcons2 = _interopRequireDefault(_ItemWithImageDescriptionAndIcons);

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _news = require("redux/modules/news");

var _softwares = require("redux/modules/softwares");

var _utils = require("utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

var _glamor = require("glamor");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prettyDate = exports.prettyDate = function prettyDate(dateString) {
  return new Date(dateString).toLocaleString("en-us", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });
};

var applications = [{
  img: cf_utils.cf_qx_page("enterprise", "JungleBook.jpg"),
  title: "Jungle Book",
  description: "Disney’s live-action remake transports audiences deep into a vivid jungle environment created with the help of Quixel tools. The film has won numerous awards including the Academy Award for Best Visual Effects.",
  secondaryLink: "/mixer",
  primaryLink: "Learn More",
  primaryLabel: "",
  // secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows and macOS',
  linkLable: "Learn More",
  link: "/blog/2016/8/23/megascans-an-indispensable-resource-for-the-jungle-book",
  Indie: true
}, {
  img: cf_utils.cf_qx_page("enterprise", "AmericanGods.jpg"),
  title: "American Gods",
  description: "This blend of Americana, fantasy, and mythology, has received critical acclaim for performances and visual style made with the help of Quixel tools. The show was nominated for the Outstanding Special Visual Effects Emmy Award.",
  secondaryLink: "/mixer",
  primaryLink: "",
  primaryLabel: "",
  //  secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows and macOS',
  linkLable: "Learn More",
  link: "/blog/2017/11/14/making-american-gods-with-megascans",
  Indie: true
}, {
  img: cf_utils.cf_qx_page("enterprise", "ADAM.jpg"),
  title: "ADAM",
  description: "Unity’s real-time-rendered short film leverages Quixel tools to help bring this dystopian story to life, and showcases photorealistic graphical quality. The film won the Webby Award in Animation (Branded).",
  secondaryLink: "/bridge",
  primaryLink: "",
  primaryLabel: "",
  // secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows, macOS and linux',
  linkLable: "Learn More",
  link: "/blog/2017/11/30/neill-blomkamps-oats-studios-chooses-quixel-megascans",
  Indie: true
}];

var Enterprise = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Enterprise, _React$Component);

  function Enterprise(props) {
    (0, _classCallCheck3.default)(this, Enterprise);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Enterprise.__proto__ || (0, _getPrototypeOf2.default)(Enterprise)).call(this, props));

    _this.state = {
      platform: "Windows"
    };
    return _this;
  }

  (0, _createClass3.default)(Enterprise, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.loaded === false && nextProps.loaded === true || this.props.news !== nextProps.news || this.state.platform !== nextState.platform || this.props.loggedIn !== nextState.loggedIn) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var platform = this.state.platform;
      var softwares = this.props.softwares;
      var mixerUpdater = softwares.mixerUpdater;


      var latestStudio = (0, _utils.getLatestVersion)(mixerUpdater, platform);

      var bridgeDownloadUrl = _utils.bridgeBuilds[platform.toLowerCase()];

      return _react2.default.createElement(
        AppSideEffects,
        {
          documentTitle: "for Enterprise",
          documentImage: cf_utils.cf_thumbs("page-thumb-enterprise.jpg"),
          documentDescription: "Made for creatives, scaled for enterprise. Get enterprise-level access to powerful tools and customized solutions to help your project succeed." },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_Hero2.default, {
            bg: cf_utils.cf_qx_page("home", "lion-king-front-page-hero.jpg"),
            title: "Made for creatives.<br>Scaled for enterprise",
            subTitle: "",
            primaryLabel: "",
            primaryTo: "",
            secondaryLabel: "GET STARTED",
            secondaryTo: "",
            hrLine: true,
            onClickSecondaryHandler: function onClickSecondaryHandler() {
              return _this2.context.dialogs.custom(_react2.default.createElement(EnterpriseSubscriptionContainer, {
                title: "Looking for an Enterprise plan?",
                description: "We would be happy to tailor a plan that suits your needs. Leave us a note and we will get back to you soon.",
                tag: "Enterprise-Subscription",
                initialValues: {
                  name: "",
                  email: "",
                  company: "",
                  phone: "",
                  position: "",
                  companyUrl: "",
                  comments: "",
                  industry: "",
                  country: ""
                }
              })).bind(_this2);
            }
          }),
          _react2.default.createElement(CompanyListing, { mode: "dark", clients: this.props.logos }),
          _react2.default.createElement(_DescriptionWith3Columns2.default, {
            title: "Why QuixeL",
            headingBeforeBreak: "Save millions and increase quality",
            headingAfterBreak: "with enterprise access.",
            columns: [{
              img: cf_utils.cf_icons("megascans_icon_2048_preview.png"),
              isIcon: true,
              title: "Megascans",
              desc: "The fastest-growing and largest resource of production ready scans. Oscar-winning quality, fully PBR and standardized, at a total value of 10 million dollars.",
              alignLeft: true
            }, {
              img: cf_utils.cf_icons("bridge_icon_2048.png"),
              isIcon: true,
              title: "Bridge",
              desc: "Save time and streamline your local content management by easily organizing all assets in one place that integrates with every DCC, engine or renderer.",
              alignLeft: true
            }, {
              img: cf_utils.cf_icons("mixer_icon_2048_preview.png"),
              isIcon: true,
              title: "Mixer",
              desc: "Significantly speed up the production of high-quality custom materials. Paint and mix both realistic and stylized tileable textures in minutes.",
              alignLeft: true
            }]
          }),
          _react2.default.createElement(_QouteSection2.default, {
            bg: cf_utils.cf_ms("home/BOD_09.jpg"),
            title: "Get ahead with the #1 content library<br>and enjoy unlimited creativity.",
            subTitle: "Unrestricted access to the fastest-growing scan library plus unlimited seats.",
            subHeading: "GUARANTEED QUALITY AND EFFICIENCY INCREASE"
          }),
          _react2.default.createElement(Feature, {
            img: cf_utils.cf_qx_page("mixer", "mixer-complete-megascans-integration.jpg"),
            title: "An outsourcing revolution.",
            featureType: "Quixel for Enterprise",
            newHome: true,
            desc: "It is our sole mission to quickly provide you with the content and tools you need to succeed. Not only do you get unlimited access to the world’s largest scan library from day one, but over 100 people scan the world every day based on your immediate needs, with unrivaled turnaround and quality.",
            link: [{
              label: "SEE HOW WE CAPTURE THE WORLD",
              href: "https://youtu.be/dtEl7WIzKHA",
              newWindow: true
            }]
          }),
          _react2.default.createElement(Feature, {
            img: cf_utils.cf_qx_page("mixer", "mixer-seamless-painting-experience.jpg"),
            title: "Unlimited creativity.",
            featureType: "Quixel for Enterprise",
            newHome: true,
            flip: true,
            desc: "Get instant unlimited access to thousands of 3D assets, surfaces, plants and more; experiment and iterate freely without worrying about wasting money or maxing out your account. With unlimited seats to all apps, you don’t have to think twice before adding new people to your creative process.",
            link: [{
              label: "GO UNLIMITED",
              onClick: function onClick() {
                return _this2.context.dialogs.custom(_react2.default.createElement(EnterpriseSubscriptionContainer, {
                  title: "Looking for an Enterprise plan?",
                  description: "We would be happy to tailor a plan that suits your needs. Leave us a note and we will get back to you soon.",
                  tag: "Enterprise-Subscription",
                  initialValues: {
                    name: "",
                    email: "",
                    company: "",
                    phone: "",
                    position: "",
                    companyUrl: "",
                    comments: "",
                    industry: "",
                    country: ""
                  }
                }));
              }
            }]
          }),
          _react2.default.createElement(Feature, {
            img: cf_utils.cf_qx_page("megascans", "megascans-no-more-guesswork.jpg"),
            title: "Unparalleled standardization.",
            featureType: "Quixel for Enterprise",
            newHome: true,
            desc: "We invest thousands of dollars into every single asset that goes into the library to ensure premium quality, total standardization and optimal performance, as well as invent all scanning hardware and software to guarantee perfect meshes and calibrated physically based maps, so you don’t have to.",
            link: [{
              href: "https://www.youtube.com/quixeltools",
              label: "SEE THE TUTORIALS"
            }]
          }),
          _react2.default.createElement(
            _Slider2.default,
            { delay: 7 },
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("dice-test.jpg"),
              icon: cf_utils.cf_testimonials("icon/dice.png"),
              title: "\u201CMegascans, Mixer, and Bridge work together so well. All of Quixel\u2019s tools clearly show that structure and high-quality content going hand in hand is a powerful way to save time and increase quality.\u201D",
              subTitle: "\u2014 Pontus Ryman, Senior Environment Artist, EA DICE",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("monster-hunter-world.jpg"),
              icon: cf_utils.cf_testimonials("icon/capcom.png"),
              title: "\u201CMegascans is a culmination of the very best assets to help simplify game development and aid in creating the highest quality games possible.\u201D",
              subTitle: "\u2014 Ryota Kanematsu, Environment Artist, Capcom",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("shadow-of-tomb-raider.jpg"),
              icon: cf_utils.cf_testimonials("icon/cdem.png"),
              title: "\u201CEidos-Montr\xE9al and Crystal Dynamics are proud to have used Quixel Megascans for Shadow of the Tomb Raider in order to help bring to life our meticulously crafted world.\u201D",
              subTitle: "\u2014 Eidos-Montr\xE9al & Crystal Dynamics",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("jungle-book.jpg"),
              icon: cf_utils.cf_testimonials("icon/technicolor.png"),
              title: "\u201CMegascans has become an indispensable resource when building photorealistic environments.\u201D",
              subTitle: "\u2014 Damien Fagnou, SVP, Technicolor",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("destiny-2.jpg"),
              icon: cf_utils.cf_testimonials("icon/bungie.png"),
              title: "\u201CMegascans provides the highest quality source material with intuitive tools to combine, permute and create unique new content.\u201D",
              subTitle: "\u2014 Tom Burlington, Technical Art Director, Bungie",
              hr: true
            })
          ),
          _react2.default.createElement(_Section2.default, {
            innerClassName: (0, _glamor.css)((0, _css.maxWidth)(_css.breakpoints.mediumlarge)({ maxWidth: "100%" })),
            mode: "dark",
            subHeading: "MADE WITH QUIXEL",
            content: applications.map(function (app) {
              return _react2.default.createElement(_ItemWithImageDescriptionAndIcons2.default, app);
            })
          }),
          _react2.default.createElement(Feature, {
            img: cf_utils.cf_qx_page("bridge", "bridge-future-proof-your-pipeline.jpg"),
            featureType: "Quixel for Enterprise",
            title: "The industry standard.",
            desc: "We are proud to have some of the happiest clients in the industry, and are committed to building not only the tools you need, but also great, long-lasting and trusting relationships. This is why virtually all major AAA and VFX studios now rely on Quixel to help shape the future of entertainment.",
            newHome: true,
            link: [{
              href: "/megascans",
              label: "EXPERIENCE MEGASCANS"
            }]
            // artist={'Illusive Images'}
          }),
          _react2.default.createElement(Feature, {
            img: cf_utils.cf_qx_page("bridge", "bridge-enterprise-sync.jpg"),
            flip: true,
            featureType: "Quixel for Enterprise",
            title: "Synced with your pipeline.",
            desc: "Bridge Sync gives your art team instant, first-class access to the entire Megascans library and latest plugins, even without internet connectivity or dedicated machines.",
            newHome: true,
            link: [{
              href: _config2.default.forumBaseUrl,
              label: "Learn More ",
              newWindow: true
            }]
            // artist={'Illusive Images'}
          }),
          _react2.default.createElement(_Hero2.default, {
            bg: cf_utils.cf_qx_page("enterprise", "Enterprise-Bottom-CTA.jpg"),
            title: "Deliver great experiences with the right tools.",
            subTitle: "Give your creative team access to the world\u2019s largest scan library and powerful creative tools to build award-winning worlds with.",
            primaryLabel: "",
            primaryTo: "",
            hrLine: true,
            secondaryLabel: "GET STARTED",
            secondaryTo: "",
            onClickSecondaryHandler: function onClickSecondaryHandler() {
              return _this2.context.dialogs.custom(_react2.default.createElement(EnterpriseSubscriptionContainer, {
                title: "Looking for an Enterprise plan?",
                description: "We would be happy to tailor a plan that suits your needs. Leave us a note and we will get back to you soon.",
                tag: "Enterprise-Subscription",
                initialValues: {
                  name: "",
                  email: "",
                  company: "",
                  phone: "",
                  position: "",
                  companyUrl: "",
                  comments: "",
                  industry: "",
                  country: ""
                }
              }));
            }
          })
        )
      );
    }
  }]);
  return Enterprise;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch;

    var studio = dispatch((0, _softwares.loadMixerUpdater)());

    return _bluebird2.default.all([studio]);
  },
  defer: function defer(_ref2) {
    var dispatch = _ref2.store.dispatch;

    return dispatch((0, _news.loadNews)(1, 5));
  }
})((0, _reactRedux.connect)(function (state) {
  return {
    news: state.news,
    loaded: state.news.loaded,
    loggedIn: state.auth.loggedIn,
    softwares: state.softwares,
    logos: state.companyLogos.megascans_wall_logos
  };
})(Enterprise));


//////////////////
// WEBPACK FOOTER
// ./src/pages/Enterprise/Enterprise.jsx
// module id = 2624
// module chunks = 0